import { render, staticRenderFns } from "./number-stepper.vue?vue&type=template&id=2bcff98a&scoped=true&lang=pug&"
import script from "./number-stepper.vue?vue&type=script&lang=coffee&"
export * from "./number-stepper.vue?vue&type=script&lang=coffee&"
import style0 from "./number-stepper.vue?vue&type=style&index=0&id=2bcff98a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcff98a",
  null
  
)

export default component.exports